import React from "react";
import {
  DateRange,
  DateRangePreset,
  formatRangeLabel,
  getPresetRange,
} from "../dateRangePresets";

interface Props {
  value: DateRange;
  onChange: (next: DateRange) => void;
}

const PRESETS: { id: DateRangePreset; label: string }[] = [
  { id: "7d", label: "7D" },
  { id: "30d", label: "30D" },
  { id: "90d", label: "90D" },
  { id: "12m", label: "12M" },
];

export function DateRangeSelector({ value, onChange }: Props) {
  return (
    <div className="flex items-center gap-3">
      <div className="text-xxs uppercase tracking-[0.18em] text-gray-600 font-medium hidden md:block">
        {formatRangeLabel(value)}
      </div>
      <div className="inline-flex items-center rounded-full border border-borderGray bg-white p-1 shadow-sm">
        {PRESETS.map((p) => {
          const active = value.preset === p.id;
          return (
            <button
              key={p.id}
              type="button"
              onClick={() => onChange(getPresetRange(p.id))}
              className={[
                "px-4 py-1.5 text-xs font-semibold tracking-wider rounded-full transition-all duration-200",
                active
                  ? "bg-primary-100 text-white shadow-sm"
                  : "text-gray-600 hover:text-black hover:bg-gray-100",
              ].join(" ")}
            >
              {p.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
